// TableTorch columns for paint inspections. Project column is only in All Projects mode.
import React from "react";
import { Link } from "react-router-dom";

export const sectionReadingsChild = (row) => {
  if (!row?.inspect_by_sections) return null;

  return (
    <table style={{ tableLayout: "fixed", width: "100%", border: "2px solid" }}>
      <tr>
        <th colSpan="5" className="text-center">
          Section Readings
        </th>
      </tr>
      <tr>
        <th>Section</th>
        <th>Average</th>
        <th>Low</th>
        <th>High</th>
        <th># Readings</th>
        <th>Complies</th>
      </tr>
      {_.map(row?.section_readings_attributes, (section) => (
        <tr>
          <td>{section?.section_size}</td>
          <td>{section?.average_dft}</td>
          <td>{section?.low_dft}</td>
          <td>{section?.high_dft}</td>
          <td>{section?.readings}</td>
          <td>{section?.complies ? "Yes" : "No"}</td>
        </tr>
      ))}
    </table>
  );
};

const paintInspectionColumns = ({ updateRole = false, allProjects = false } = {}) => {
  let columns = [];

  if (allProjects) {
    columns.push({
      header: "Project",
      dataKey: "project_display_name",
      sort: true,
      disableReportOption: true,
    });
  }

  columns = columns.concat([
    {
      header: "Assembly",
      dataKey: "assembly.display_name_with_guid",
      sort: true,
      disableReportOption: true,
    },
    {
      header: "Phase",
      dataKey: "assembly.phase",
      sort: true,
      className: "w-50px",
      disableReportOption: true,
    },
    {
      header: "Lot",
      dataKey: "assembly.lot",
      sort: true,
      className: "w-50px",
      disableReportOption: true,
    },
    {
      header: "Paint System",
      dataKey: "paint_system_display_code",
      sort: true,
      disableReportOption: true,
    },
    {
      header: "Inspection #",
      dataKey: "number",
      sort: true,
      disableReportOption: true,
    },
    {
      header: "Coat",
      dataKey: "coat_display_name",
      sort: true,
      disableReportOption: true,
    },
    {
      header: "Inspection Location",
      dataKey: "location_name",
      sort: true,
      disableReportOption: true,
    },
    {
      header: "Painter",
      dataKey: "painter_name",
      sort: true,
      disableReportOption: true,
    },
    {
      header: "Date",
      dataKey: "created_at",
      sort: true,
      cellRenderer: (_cell, row) => row.created_at_display,
      disableReportOption: true,
    },
    {
      header: "Average DFT",
      dataKey: "average_dft",
      sort: true,
      className: "w-75px",
    },
    {
      header: "Low DFT",
      dataKey: "low_dft",
      sort: true,
      className: "w-75px",
    },
    {
      header: "High DFT",
      dataKey: "high_dft",
      sort: true,
      className: "w-75px",
    },
    {
      header: "# Readings",
      dataKey: "readings",
      sort: true,
    },
    {
      header: "Complies",
      dataKey: "complies",
      cellRenderer: (cellData, row) => {
        if (row.inspect_by_sections) {
          return row.section_readings_attributes.every((sr) => sr.complies) ? "Yes" : "No";
        }
        return cellData ? "Yes" : "No";
      },
    },
  ]);

  if (updateRole) {
    columns.push({
      header: "Edit",
      dataKey: "edit",
      cellRenderer: (cell, row) => (
        <Link to={`/project/${row?.assembly?.project_id}/qa/paint_inspections/${row.id}/edit`}>Edit</Link>
      ),
      print: false,
    });
  }

  return columns;
};

export default paintInspectionColumns;
